const eventHub = {
  install: function (Vue, _options) {
    const main = new Vue()
    Vue.prototype.$eventHub = main
  }
}
export default eventHub
